<div class="authincation">
  <div class="container-fluid h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-4 col-md-7 col-sm-12 mx-auto mt-md-0 mt-4">
        @if(showOtpForm){
          <div>
            <app-two-factor
            [verificationType]="verificationType"
            (goBackOn)="onGoBack()"
            (resendCodeOn)="resendCode()"
            [beginningTime]="300"
            (sendCodeOn)="sendOtpCode($event)"
            ></app-two-factor>
          </div>

        }@else{
          <div class="login-form p-4">
            <div class="text-center">
              <h3 class="title">{{ "auth.forget-password" | translate }}</h3>
            </div>

              <form (ngSubmit)="submitForm()" #forgotPasswordForm="ngForm">
                <div class="mb-4">
                  <label class="mb-1 text-dark required-star" for="">Email</label>
                  <input
                    type="email"
                    [(ngModel)]="email"
                    name="email"
                    class="form-control"
                    #emailInput="ngModel"
                    [placeholder]="'auth.forget-password-placeholder' | translate"
                    required
                  />
                  <div *ngIf="isSubmitted && !email" class="text-danger">
                    {{ "validation.required" | translate }}
                  </div>
                </div>
                <div class="text-center mb-4">
                  <button type="submit" class="btn btn-primary btn-block">
                    {{ "auth.continue" | translate }}
                  </button>
                </div>
              </form>

          </div>
        }
      </div>
      <div class="col-lg-6 col-md-5 d-none d-md-block">
        <div class="login-media text-center mt-md-0 mt-4">
          <img
            src="assets/theme/w3crm/images/acibadem-mobil-logo.png"
            class="acibadem-logo"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</div>
